import React, { useState, useEffect, useMemo } from "react";
import {
  Badge,
  ToggleButtonGroup,
  ToggleButton,
  Row,
  Col,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { ClearButton, Typeahead } from "react-bootstrap-typeahead";

const styles = {
  card: {
    fontSize: 14,
    marginBottom: 25,
  },
  toggleButton: {
    borderColor: "black",
    color: "black",
    maxWidth: 250,
  },
  toggleButtonGroup: {
    width: "100%",
    marginBottom: 10,
    justifyContent: "center",
  },
  cardHeader: {
    color: "white",
    backgroundColor: "#566573",
    fontWeight: "bold",
    paddingTop: 5,
    paddingBottom: 5,
  },
};

const ag_to_eclipse_mapping = require("../../assets/json/ag_to_eclipse_mapping_vic.json");

const BranchFilterComponentAG = ({ handleBranchFilterTaHOC }) => {
  const [filteredBranchList, setFilteredBranchList] = useState(
    ag_to_eclipse_mapping
  );

  const [selectedBranch, setSelectedBranch] = useState([]);

  const taRefBranch = React.useRef();

  const handleBranchFilterTa = (selected) => {
    if (selected?.length > 0) {
      setSelectedBranch(selected);
      const selectedBranch = selected.map((b) => b.guid);
      console.log("selectedBranch", selectedBranch);
      handleBranchFilterTaHOC(selectedBranch[0]);
    } else if (selected.length === 0) {
      setSelectedBranch([]);
      handleBranchFilterTaHOC([]);
    }
    // console.log("qsref", taRefBranch.current);
    console.log("selection", selected);
  };

  return (
    <>
      <Row className="mt-3">
        <Col>
          {/* <h5 style={{ textAlign: "left" }}>Multi-branch select</h5> */}
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text id="basic-addon1-branch">
                Branch filter<sup>*</sup>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Typeahead
              id="onclear-branch"
              name="branch"
              ref={taRefBranch}
              options={filteredBranchList}
              defaultSelected={[]}
              onChange={handleBranchFilterTa}
              multiple={false}
              labelKey="eclipse_name"
              placeholder="Choose a branch..."
            >
              {({ onClear, selected }) => (
                <div className="rbt-aux">
                  {!!selected.length && <ClearButton onClick={onClear} />}
                  {!selected.length && <Spinner animation="grow" size="sm" />}
                </div>
              )}
            </Typeahead>
          </InputGroup>
        </Col>
      </Row>
      {/* 
      {branchBatchRows.map((row, jdx) => {
        const GRID_SIZE = 8;
        // console.log("grouprow", row * GRID_SIZE + GRID_SIZE);
        // console.log("list length", filteredBranchList.length);
        // console.log(row * GRID_SIZE + GRID_SIZE > filteredBranchList.length);
        if (row * GRID_SIZE + GRID_SIZE - 1 > filteredBranchList.length) {
          // return null;
        }
        return (
          <ToggleButtonGroup
            style={styles.toggleButtonGroup}
            name="site_filter"
            size="sm"
            onChange={(value) => {
              handleBranchFilter(value);
            }}
            value={branchFilter}
            key={jdx}
          >
            {filteredBranchList
              .slice(
                row * GRID_SIZE,
                Math.min(row * GRID_SIZE + GRID_SIZE, filteredBranchList.length)
              )
              .map((b, idx) => {
                // console.log(
                //   "gridpos",
                //   jdx,
                //   idx,
                //   row * GRID_SIZE,
                //   row * GRID_SIZE + GRID_SIZE,
                //   filteredBranchList.length
                // );
                if (b.branch?.length > 0) {
                  return (
                    <ToggleButton
                      style={styles.toggleButton}
                      value={b.branch}
                      variant="outline-success"
                      key={idx}
                    >
                      {b.branch}
                    </ToggleButton>
                  );
                }
              })}
          </ToggleButtonGroup>
        );
      })} */}
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return (
    prevProps.branchFilter === nextProps.branchFilter &&
    prevProps.branchesList === nextProps.branchesList
  );
}

export const BranchFilterComponentAGMemo = React.memo(
  BranchFilterComponentAG,
  areEqual
);
